import PropTypes from 'prop-types';
import { useI18n } from '../../../../context/I18nContext';
import './CreateConversationButton.css';

const CreateConversationButton = ({
  fill = false,
  style = {},
  size = 24,
  onClick = () => {},
}) => {
  const { t } = useI18n();

  const mergedStyle = {
    display: 'inline-block',
    width: size + 'px',
    height: size + 'px',
    verticalAlign: 'middle',
    ...style,
  };

  // Default: red circle with plus, Filled: white on red background
  const iconFill = fill ? '#FFFFFF' : '#DE4858';

  return (
    <div
      className="create-conversation-button"
      title={t('ContainerListView.startConversation')}
      onClick={onClick}
    >
      <svg width={size + 'px'} height={size + 'px'} viewBox="0 0 40 40" style={mergedStyle} fill="none">
        <path d="M20 4C16.8355 4 13.7421 4.93838 11.1109 6.69649C8.4797 8.45459 6.42894 10.9534 5.21793 13.8771C4.00693 16.8007 3.69008 20.0177 4.30744 23.1214C4.92481 26.2251 6.44866 29.0761 8.6863 31.3137C10.9239 33.5513 13.7749 35.0752 16.8786 35.6926C19.9823 36.3099 23.1993 35.9931 26.1229 34.7821C29.0466 33.5711 31.5454 31.5203 33.3035 28.8891C35.0616 26.2579 36 23.1645 36 20C35.9953 15.758 34.3081 11.6911 31.3085 8.69149C28.309 5.69193 24.242 4.00471 20 4ZM20 32.4444C17.5387 32.4444 15.1327 31.7146 13.0862 30.3472C11.0398 28.9798 9.44473 27.0362 8.50284 24.7623C7.56095 22.4884 7.31451 19.9862 7.79468 17.5722C8.27485 15.1582 9.46007 12.9408 11.2005 11.2004C12.9408 9.46006 15.1582 8.27484 17.5722 7.79467C19.9862 7.3145 22.4884 7.56094 24.7623 8.50283C27.0362 9.44472 28.9798 11.0398 30.3472 13.0862C31.7146 15.1327 32.4444 17.5387 32.4444 20C32.4409 23.2994 31.1287 26.4626 28.7957 28.7956C26.4626 31.1287 23.2994 32.4409 20 32.4444ZM27.7037 20C27.7037 20.4715 27.5164 20.9237 27.183 21.2571C26.8496 21.5905 26.3974 21.7778 25.9259 21.7778H21.7778V25.9259C21.7778 26.3974 21.5905 26.8496 21.2571 27.183C20.9237 27.5164 20.4715 27.7037 20 27.7037C19.5285 27.7037 19.0763 27.5164 18.7429 27.183C18.4095 26.8496 18.2222 26.3974 18.2222 25.9259V21.7778H14.0741C13.6026 21.7778 13.1504 21.5905 12.817 21.2571C12.4836 20.9237 12.2963 20.4715 12.2963 20C12.2963 19.5285 12.4836 19.0763 12.817 18.7429C13.1504 18.4095 13.6026 18.2222 14.0741 18.2222H18.2222V14.0741C18.2222 13.6026 18.4095 13.1504 18.7429 12.817C19.0763 12.4836 19.5285 12.2963 20 12.2963C20.4715 12.2963 20.9237 12.4836 21.2571 12.817C21.5905 13.1504 21.7778 13.6026 21.7778 14.0741V18.2222H25.9259C26.3974 18.2222 26.8496 18.4095 27.183 18.7429C27.5164 19.0763 27.7037 19.5285 27.7037 20Z" fill={iconFill}/>
      </svg>
    </div>
  );
};

CreateConversationButton.propTypes = {
  fill: PropTypes.bool,
  style: PropTypes.object,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default CreateConversationButton;
